import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutCrudIndexComponent } from './layout-crud-index.component';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { FilterCrudIndexModule } from './filter-crud-index/filter-crud-index.module';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    LayoutCrudIndexComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TableResponsiveModule,
    FilterCrudIndexModule,
    FlexLayoutModule
  ],
  exports: [LayoutCrudIndexComponent]
})
export class LayoutCrudIndexModule { }
